import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { ConvertedComponentData, FsCatalog, Image } from '../types'
import { CmsConverterService, defaultFSCatalog } from '../../services/cms-converter/cms-converter.service'

@Injectable({ providedIn: 'root' })
export class SplitContainerConverter extends CmsConverterService<SplitContainerData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const title = formData.st_title_text?.value
    const altText = formData.st_alt_text?.value
    const lazyLoad = formData.st_image_lazy_loading?.value
    return {
      imageDesktop: CmsConverterService.mapImage(formData.st_backgroundimage_reference, lazyLoad, altText, title),
      itemsLeft: formData.st_left_content ?? defaultFSCatalog,
      itemsRight: formData.st_right_content ?? defaultFSCatalog,
    }
  }
}

export const SPLIT_CONTAINER_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, SplitContainerData>>('SplitContainerConverter')

export interface SplitContainerData extends ConvertedComponentData {
  imageDesktop: Image;
  itemsLeft: FsCatalog;
  itemsRight: FsCatalog;
}
